import React from 'react';
import { useTranslation } from 'react-i18next';
import { Regions, SwissLanguages, useConfiguration } from '../../hooks/useConfiguration';
import { assertNever } from '../../utils/assertNever';
import { resolvePath } from '../../utils/resolvePath';
import { AboutItem } from './aboutItem';


export const DeclarationOfConformity: React.FC<{
  region: Regions;
}> = ({ region }) => {
  const { t, i18n } = useTranslation(region);
  const config = useConfiguration();

  switch (region) {
    case 'us':
      return null;

    case 'eu':
      return (
        <>
          <h2>{t('about.declarationOfConformity.title')}</h2>
          <p>{t('about.declarationOfConformity.text')}</p>
          <AboutItem src={resolvePath('address.png')} alt='address'>
            {t('contactData.companyName')}<br/>
            {t('contactData.street')}<br/>
            {t('contactData.city')}<br/>
            {t('contactData.country')}
          </AboutItem>
          <AboutItem src={resolvePath('ce.png')} alt='ce'/>
          {config?.swissAddress && SwissLanguages.includes(i18n.language) && (
            <AboutItem src={resolvePath('ch-rep.png')} alt='CH-REP'>
              {config.swissAddress}
            </AboutItem>
          )}
          <hr />
        </>
      );

    default:
      assertNever(region);
  }
};
